import type { WorkflowRun } from '../api/workflowRuns'
import { createAsyncTaskHub } from './asyncTaskHub'
import { SSE_EVENT_WORKFLOW_RUN_UPDATED } from './sseEventNames'

export const workflowRunHub = createAsyncTaskHub<WorkflowRun>({
  path: '/v1/workflow-runs/events',
  eventName: SSE_EVENT_WORKFLOW_RUN_UPDATED,
  getId: (run) => run.publicId,
})

export function isTerminalWorkflowRun(run: WorkflowRun) {
  return run.status === 'succeeded' || run.status === 'failed' || run.status === 'cancelled'
}
